import { Injectable } from '@angular/core';
import { AutosuggestApiService } from '@shared/api';
import { Pagination } from '@ui-kit/miscs';
import { AutoComplete } from 'primeng/autocomplete';

export interface AutocompleteSettings {
    id: string;
    fluid?: boolean;
    maxLength: number | null;
    forceSelection: boolean;
    optionLabel: string;
    optionValue: string;
    lazy: boolean;
    showClear: boolean;
    required: boolean;
    isUser?: boolean;
    emitOnHide: boolean;
    emitOnBlur: boolean;
    multiple: boolean;
    panelClass: string;
    getSuggestions: (value: string, pagination: Pagination) => Promise<any[]>;
}

export const AUTOCOMPLETE_FETCH_LIMIT = 30;

@Injectable({ providedIn: 'root' })
export class AutocompleteService {
    private activeAutocomplete: AutoComplete | null = null;

    constructor(private autosuggestApi: AutosuggestApiService) {}

    setActiveAutocomplete(autocomplete: AutoComplete): void {
        if (this.activeAutocomplete && this.activeAutocomplete !== autocomplete) {
            this.activeAutocomplete.hide();
        }

        this.activeAutocomplete = autocomplete;
    }

    clearActiveAutocomplete(autocomplete: AutoComplete): void {
        if (this.activeAutocomplete === autocomplete) {
            this.activeAutocomplete = null;
        }
    }

    user(): AutocompleteSettings {
        return {
            id: 'user-autocomplete',
            maxLength: 300,
            fluid: true,
            forceSelection: false,
            optionLabel: 'name',
            optionValue: 'id',
            lazy: true,
            showClear: true,
            required: false,
            isUser: true,
            emitOnHide: true,
            emitOnBlur: false,
            multiple: false,
            panelClass: 'user-autocomplete-panel',
            getSuggestions: async (value: string, pagination?: Pagination) => {
                const response = await this.autosuggestApi.suggestUsers({
                    searchValue: value?.trim() ?? '',
                    take: AUTOCOMPLETE_FETCH_LIMIT,
                    skip: pagination?.skip ?? 0,
                });
                return response.data ?? [];
            },
        };
    }
}
